var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewDoubts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comment-dots",
    d: "M12.836.029A12,12,0,0,0,.03,12.854C.47,19.208,6.082,24,13.084,24H19a5.006,5.006,0,0,0,5-5V12.34A12.21,12.21,0,0,0,12.836.029ZM7,13.5A1.5,1.5,0,1,1,8.5,12,1.5,1.5,0,0,1,7,13.5Zm5,0A1.5,1.5,0,1,1,13.5,12,1.5,1.5,0,0,1,12,13.5Zm5,0A1.5,1.5,0,1,1,18.5,12,1.5,1.5,0,0,1,17,13.5Z",
    transform: "translate(-0.001 -0.001)",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDoubts);
export default __webpack_public_path__ + "static/media/view-doubts.9e01eb691ed459e92f59b2ab8588f495.svg";
export { ForwardRef as ReactComponent };